<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-select style="width: 100%;" filterable clearable  v-model="searchInfo.id" placeholder="请选择校区">
					<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 300px;">
					<el-button type="primary" @click="searchHisSet" icon="el-icon-search">搜索</el-button>
					<el-button type="primary" icon="el-icon-plus" @click="addHisSet">新增</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="sysHisSetList"  style="width: 100%"  max-height="700">
			    <el-table-column fixed="left" prop="orgname" label="所属校区" width="150" align="center"></el-table-column>
			    <el-table-column prop="totalpowername" label="总耗电(加)" align="center"></el-table-column>
				<el-table-column prop="airpowername" label="空调耗电(加)" align="center"></el-table-column>
				<el-table-column prop="lightpowername" label="照明耗电(加)" align="center"></el-table-column>
				<el-table-column prop="otherpowername" label="其他耗电(加)" align="center"></el-table-column>
				<el-table-column prop="minstotalpowername" label="总耗电(减)" align="center"></el-table-column>
				<el-table-column prop="minsairpowername" label="空调耗电(减)" align="center"></el-table-column>
				<el-table-column prop="minslightpowername" label="照明耗电(减)" align="center"></el-table-column>
				<el-table-column prop="minsotherpowername" label="其他耗电(减)" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goHisSetDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
						<a @click="deleteDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="hisSetTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<HisSetDetail @needRefrash="needRefrash" :add="isadd" :allOrgTree="allOrgTree" :selectedhis="selectset"></HisSetDetail>
		</el-dialog> 
	</div>
</template>

<script>
	import { queryHisPowerSetByPage, deleteHisPowerSet, queryAllOrgTree, queryAllOrg } from '/static/apiUrl.js'
	import HisSetDetail from './hissetdetail'
	export default {
		name : 'HisSetList',
		data() {
			return {
				detailShow: false,
				editok : false,
				isadd : false,
				detailTitle: '报表点详情',
				selectset: null,	
				param : {
					page : 1,
					pagenum : 10,
				},
				orgList : [],
				searchInfo:{
					name: '',
					id : '',
				},
				hisSetTotal : 0,
				sysHisSetList : [],
				allOrgTree : [],
				
			}
		},
		mounted() {
			this.initData()
			this.queryHisList()
		},
		components: {
			HisSetDetail,
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryHisList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryHisList()
			},
			initData() {
				this.allOrgTree = []
				queryAllOrgTree().then(res => {
					if(0 == res.code){
						this.allOrgTree = res.datas
					}
				})
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							if("XQ" == org.type){
								this.orgList.push(org)
							}
						})
					}
				})
			},
			searchHisSet(){
				this.param.page = 1
				this.sysHisSetList = []
				this.queryHisList()
			},
			clearSearch(){
				this.param.page = 1
				this.queryHisList()
			},
			queryHisList(){
				this.sysHisSetList = []
				queryHisPowerSetByPage({
					oid: this.searchInfo.id,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.hisSetTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysHisSetList.push(set)
						})
					}
				})
			},
			goHisSetDetail(idx,row){
				this.detailTitle = '报表点位详情'
				this.isadd = false
				this.selectset = JSON.parse(JSON.stringify(this.sysHisSetList[idx]))
				this.detailShow = true
			},
			deleteDetail(idx,row){
				this.$confirm('此操作将删除报表配置点位 '+this.sysHisSetList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteHisPowerSet({
						id : this.sysHisSetList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryHisList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addHisSet(){
				this.detailTitle = "新增计算点位"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
			},
			needRefrash(val,isshow){
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				if(this.editok){
					this.queryHisList()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>